const SCREEN = {
  SETTLEMENT_INFO: 'Settlement Info',
  AUTO_DEBIT_REGISTRATION_INSTRUCTION: 'Auto Debit Registration Instruction',
  SETTLEMENT_INFO_CHANGE_CONFIRMATION: 'Settlement Info Change Confirmation',
  BILL_SETTLEMENT_OPTIONS: 'Bill Settlement Options',
  BILL_SETTLEMENT_THANK_YOU: 'Bill Settlement Thank You',
  BILL_SETTLEMENT_INSTRUCTIONS: 'Bill Settlement Instructions',
  BANK_TRANSFER: 'Bank Transfer',
  BANK_TRANSFER_FALLBACK: 'Bank Transfer Fallback',
  HOME_SCREEN: 'Home Screen',
  HOW_TO: 'How To',
};

const ITEM = {
  SETTLEMENT_INFO: 'Settlement Info',
  APPLY_FOR_AUTO_DEBIT: 'Apply for Auto Debit',
  CHANGE_TO_AUTO_DEBIT: 'Change to Auto Debit',
  CHANGE_TO_COMBINI: 'Change to Combini',
  UNREGISTER_BANK: 'Unregister Bank',
  NEXT: 'Next',
  SUPPORTED_BANKS: 'Supported Banks',
  SUBMIT: 'Submit',
  BACK: 'Back',
  BANK_TRANSFER: 'Bank Transfer',
  COMBINI: 'Combini',
  APPLE_BANNER: 'Apple Banner',
  SHOPPING_BANNER: 'Shopping banner',
  AMAZON_BANNER: 'Amazon 6 pay banner',
  PAY_LATER: 'Pay Later',
  SETTLEMENT_METHODS: 'settlement methods',
  N_PAY: '3 / 6 / 12 Pay',
  SHOPPING: 'Shopping',
};

const ACTION = {
  PAGE_VIEW: 'Page View',
  CLICK: 'Click',
  SUCCESS: 'Success',
  ERROR: 'Error',
};

export { ACTION, ITEM, SCREEN };
